import React from 'react';
import { StepProps } from '../MultiStepModal';
import { useClientsData } from '../../../hooks/useData';

type ClientOption = {
  id: string;
  name: string;
};

export default function AddSiteStep({ data, onDataChange }: StepProps) {
  const { data: clients = [], isLoading } = useClientsData();

  const clientOptions: ClientOption[] = Array.isArray(clients)
    ? clients
        .filter((c: any) => c && c.id)
        .map((c: any) => ({ id: String(c.id), name: String(c.name || c.company || 'Client') }))
    : [];

  const handleInputChange = (field: string, value: string) => {
    onDataChange({ [field]: value });
  };

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Site Details</h3>
        <p className="step-form-subtitle">Add property details and access notes</p>
      </div>

      <form className="step-form-content">
        <div className="form-group">
          <label className="form-label">Client</label>
          <select
            className="form-select"
            value={data.clientId || ''}
            onChange={(e) => handleInputChange('clientId', e.target.value)}
          >
            <option value="">Select client</option>
            {isLoading ? (
              <option value="" disabled>
                Loading clients...
              </option>
            ) : null}
            {clientOptions.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Address line 1</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g., 12 High Street"
            value={data.addressLine1 || ''}
            onChange={(e) => handleInputChange('addressLine1', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Address line 2</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g., Flat 3"
            value={data.addressLine2 || ''}
            onChange={(e) => handleInputChange('addressLine2', e.target.value)}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">City</label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., London"
              value={data.city || ''}
              onChange={(e) => handleInputChange('city', e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Postcode</label>
            <input
              type="text"
              className="form-input"
              placeholder="e.g., SW1A 1AA"
              value={data.postcode || ''}
              onChange={(e) => handleInputChange('postcode', e.target.value)}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Property type</label>
          <select
            className="form-select"
            value={data.propertyType || ''}
            onChange={(e) => handleInputChange('propertyType', e.target.value)}
          >
            <option value="">Select property type</option>
            <option value="Domestic">Domestic</option>
            <option value="Commercial">Commercial</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Access notes</label>
          <textarea
            className="form-textarea"
            placeholder="Anything the engineer needs to know about access…"
            rows={4}
            value={data.accessNotes || ''}
            onChange={(e) => handleInputChange('accessNotes', e.target.value)}
          />
        </div>
      </form>
    </div>
  );
}
